import { ChangeEvent, useState } from "react";

import { InfoPanel, Select, SelectData, Typography } from "@king-ict/eupisi-ui/components";
import { ReactComponent as InfoIcon } from "@king-ict/eupisi-ui/components/Icon/Info.svg";
import { CodeBook } from "@king-ict/eupisi-ui/models";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { InstitutionListItem, PedagogicalYear } from "../../models";
import { EnrollmentListCapacityTrackerModal } from "./EnrollmentListCapacityTrackerModal";
import styles from "./EnrollmentListHeader.module.scss";

export interface EnrollmentListHeaderProps {
  infoMessage: string;
  title: string;
  pedagogicalYearId?: number;
  pedagogicalYears: PedagogicalYear[];
  onChangePedagogicalYear: (event: ChangeEvent<any>) => void;
  monthId?: number;
  months?: CodeBook[];
  onChangeMonth?: (event: ChangeEvent<any>) => void;
  institutionsCapacities: InstitutionListItem[];
}

export const EnrollmentListHeader = ({
  infoMessage,
  title,
  pedagogicalYearId,
  pedagogicalYears,
  onChangePedagogicalYear,
  monthId,
  months,
  onChangeMonth,
  institutionsCapacities
}: EnrollmentListHeaderProps) => {
  const { t } = useTranslation();

  const [capacityTrackerModalOpen, setCapacityTrackerModalOpen] = useState(
    false
  );

  const handlerCloseDetails = () => {
    setCapacityTrackerModalOpen(false);
  };

  const handleOpenCapacityTracker = () => {
    setCapacityTrackerModalOpen(true);
  };

  return (
    <>
      <Row className={styles.marginHeader}>
        <Col xs={12} className={styles.padding0}>
          <InfoPanel
            color="success"
            message={infoMessage}
            fullWidth
            className={styles.info}
          ></InfoPanel>
        </Col>
        <Col xs={12} className={styles.padding0}>

          <Row className={styles.margin0}>
            <Col xs={6} md={6}>
              <Typography variant="XLargeBold" className={styles.title}>
                {title}
              </Typography>
            </Col>
            <Col xs={6} md={6} className={styles.institutionInfo}>
              <div
                className={styles.infoSection}
                onClick={handleOpenCapacityTracker}
              >
                <Typography variant="mediumBold" component="h3" color="primary">
                  {t("enrollmentList.capacityKindergarten")}
                </Typography>
                <InfoIcon />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className={styles.margin1em}>
          <Col xs={6}>
          <div className="form-inline">
          <Typography variant="baseBold" component="span">
              {t("common.pedagogicalYear")}
            </Typography>
           
              <Select
                borderless
                value={pedagogicalYearId}
                onChange={onChangePedagogicalYear}
                selectData={
                  {
                    valueProp: "id",
                    textProp: "name",
                    data: pedagogicalYears,
                  } as SelectData<PedagogicalYear>
                }
              />
            </div>
          </Col>
       
        {months && months.length > 0 &&
            <>
             <Col xs={6}>
             <div className="form-inline">
             <Typography variant="baseBold" component="span">
                {t("common.month")}
              </Typography>
              
                <Select
                  borderless
                  emptyOption={{
                    value: undefined,
                    text: t("common.allMonths"),
                  }}
                  className={styles.monthSelect}
                  value={monthId}
                  onChange={onChangeMonth ?? ((e) => {})}
                  selectData={
                    {
                      valueProp: "id",
                      textProp: "name",
                      data: months,
                    } as SelectData<CodeBook>
                  }
                />
              </div>
             </Col>             
            </>
          }
        </Row>
      <Row>
       
      </Row>
      {capacityTrackerModalOpen ? (
        <EnrollmentListCapacityTrackerModal
          kindergartenCapacity={institutionsCapacities}
          capacityTrackerModalOpen={capacityTrackerModalOpen}
          handlerCloseDetails={handlerCloseDetails}
        ></EnrollmentListCapacityTrackerModal>
      ) : (
        <></>
      )}
    </>
  );
};
